/**
 * Created by rkotha on 8/17/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators'];
        $stateProvider.state('home', {
            abstract: true,
            parent: 'app'
        }).state('home-main', {
            abstract: true,
            parent: 'home',
            url: '/home-main',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.homePage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('home-main.home-page', {
            url: '/adminhomePage',
            templateUrl: 'app/home/home-page/home-page.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.homePage.home.title'
            },
            controller: 'HomePageController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homePage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                homeEntities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'home'}).$promise;
                }]
            }
        }).state('home-main.arris-account-contacts', {
            url: '/arrisAccountContacts',
            templateUrl: 'app/home/arris-account-contacts/arris-account-contacts.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.arrisAccountContacts.home.title'
            },
            controller: 'ArrisAccountContactsController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('arrisAccountContacts');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'arrisAccountContacts'}).$promise;
                }]
            }
        }).state('home-main.important-announcements', {
            url: '/importantAnnouncements',
            templateUrl: 'app/home/important-announcements/important-announcements.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.importantAnnouncements.home.title'
            },
            controller: 'ImportantAnnouncementsController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('importantAnnouncements');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'importantAnnouncements'}).$promise;
                }]
            }
        });
    }
})();
